/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonthlyReceivables
 */
export interface MonthlyReceivables {
    /**
     * YYYY-MM format
     * @type {string}
     * @memberof MonthlyReceivables
     */
    month: string;
    /**
     * Human-readable month label, e.g. Jan 2025
     * @type {string}
     * @memberof MonthlyReceivables
     */
    label: string;
    /**
     * Number of claims in this month
     * @type {number}
     * @memberof MonthlyReceivables
     */
    claimCount: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyReceivables
     */
    rcvCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyReceivables
     */
    depreciationCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyReceivables
     */
    acvCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyReceivables
     */
    deductibleCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyReceivables
     */
    netClaimCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyReceivables
     */
    recoverableDepreciationCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyReceivables
     */
    nonRecoverableDepreciationCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyReceivables
     */
    netWithRecoverableCents: number;
}

/**
 * Check if a given object implements the MonthlyReceivables interface.
 */
export function instanceOfMonthlyReceivables(value: object): value is MonthlyReceivables {
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('claimCount' in value) || value['claimCount'] === undefined) return false;
    if (!('rcvCents' in value) || value['rcvCents'] === undefined) return false;
    if (!('depreciationCents' in value) || value['depreciationCents'] === undefined) return false;
    if (!('acvCents' in value) || value['acvCents'] === undefined) return false;
    if (!('deductibleCents' in value) || value['deductibleCents'] === undefined) return false;
    if (!('netClaimCents' in value) || value['netClaimCents'] === undefined) return false;
    if (!('recoverableDepreciationCents' in value) || value['recoverableDepreciationCents'] === undefined) return false;
    if (!('nonRecoverableDepreciationCents' in value) || value['nonRecoverableDepreciationCents'] === undefined) return false;
    if (!('netWithRecoverableCents' in value) || value['netWithRecoverableCents'] === undefined) return false;
    return true;
}

export function MonthlyReceivablesFromJSON(json: any): MonthlyReceivables {
    return MonthlyReceivablesFromJSONTyped(json, false);
}

export function MonthlyReceivablesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthlyReceivables {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'],
        'label': json['label'],
        'claimCount': json['claimCount'],
        'rcvCents': json['rcvCents'],
        'depreciationCents': json['depreciationCents'],
        'acvCents': json['acvCents'],
        'deductibleCents': json['deductibleCents'],
        'netClaimCents': json['netClaimCents'],
        'recoverableDepreciationCents': json['recoverableDepreciationCents'],
        'nonRecoverableDepreciationCents': json['nonRecoverableDepreciationCents'],
        'netWithRecoverableCents': json['netWithRecoverableCents'],
    };
}

export function MonthlyReceivablesToJSON(json: any): MonthlyReceivables {
    return MonthlyReceivablesToJSONTyped(json, false);
}

export function MonthlyReceivablesToJSONTyped(value?: MonthlyReceivables | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'label': value['label'],
        'claimCount': value['claimCount'],
        'rcvCents': value['rcvCents'],
        'depreciationCents': value['depreciationCents'],
        'acvCents': value['acvCents'],
        'deductibleCents': value['deductibleCents'],
        'netClaimCents': value['netClaimCents'],
        'recoverableDepreciationCents': value['recoverableDepreciationCents'],
        'nonRecoverableDepreciationCents': value['nonRecoverableDepreciationCents'],
        'netWithRecoverableCents': value['netWithRecoverableCents'],
    };
}

